import React from "react";
import styled from "styled-components";
import { useAppShell } from "./AppShell";

const HeaderContainer = styled.header`
  background: linear-gradient(135deg, #00875a 0%, #36b37e 100%);
  padding: 0.5rem 1rem;
  box-shadow: 0 1px 2px rgba(9, 30, 66, 0.08);
  color: white;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);

  @media (min-width: 768px) {
    padding: 0.5rem 1.5rem;
  }
`;

const HeaderContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 1400px;
  margin: 0 auto;
  gap: 0.5rem;

  @media (min-width: 768px) {
    gap: 1.5rem;
  }
`;

const LeftSection = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex: 1;
  min-width: 0;

  @media (min-width: 768px) {
    gap: 1.5rem;
  }
`;

const MenuButton = styled.button`
  background-color: rgba(255, 255, 255, 0.15);
  color: white;
  border: 1px solid rgba(255, 255, 255, 0.25);
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 3px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 1.25rem;
  font-weight: 700;
  line-height: 1;
  padding: 0;

  @media (min-width: 768px) {
    width: 2rem;
    height: 2rem;
    font-size: 1rem;
  }

  &:hover {
    background-color: rgba(255, 255, 255, 0.25);
    border-color: rgba(255, 255, 255, 0.4);
  }
`;

const DateSection = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: wrap;

  @media (min-width: 768px) {
    gap: 0.75rem;
  }
`;

const DateDisplay = styled.h1`
  font-size: 1rem;
  font-weight: 600;
  margin: 0;
  color: white;
  letter-spacing: -0.01em;
  white-space: nowrap;

  @media (min-width: 768px) {
    font-size: 1.25rem;
  }
`;

const NavigationButtons = styled.div`
  display: flex;
  gap: 0.25rem;

  @media (min-width: 768px) {
    gap: 0.5rem;
  }
`;

const NavButton = styled.button`
  background-color: rgba(255, 255, 255, 0.15);
  color: white;
  border: 1px solid rgba(255, 255, 255, 0.25);
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 3px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 1.5rem;
  font-weight: 600;
  line-height: 1;
  transition: all 0.15s ease;
  padding: 0;

  @media (min-width: 768px) {
    width: 2rem;
    height: 2rem;
    font-size: 1.5rem;
  }

  &:hover {
    background-color: rgba(255, 255, 255, 0.25);
    border-color: rgba(255, 255, 255, 0.4);
  }

  &:active {
    background-color: rgba(255, 255, 255, 0.3);
    transform: scale(0.95);
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.5);
  }
`;

const TodayButton = styled.button`
  background-color: rgba(255, 255, 255, 0.15);
  color: white;
  border: 1px solid rgba(255, 255, 255, 0.25);
  padding: 0.25rem 0.5rem;
  border-radius: 3px;
  cursor: pointer;
  font-size: 0.75rem;
  font-weight: 600;
  transition: all 0.15s ease;
  line-height: 1.5;
  white-space: nowrap;

  @media (min-width: 768px) {
    padding: 0.375rem 0.875rem;
    font-size: 0.875rem;
  }

  &:hover {
    background-color: rgba(255, 255, 255, 0.25);
    border-color: rgba(255, 255, 255, 0.4);
  }

  &:active {
    background-color: rgba(255, 255, 255, 0.3);
    transform: scale(0.98);
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.5);
  }
`;

const WorkplaceName = styled.p`
  font-size: 0.75rem;
  font-weight: 500;
  margin: 0;
  margin-left: auto;
  color: rgba(255, 255, 255, 0.95);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  @media (min-width: 768px) {
    font-size: 0.875rem;
  }
`;

const RightSection = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;

  @media (min-width: 768px) {
    gap: 0.75rem;
  }
`;

const DownloadButton = styled.button`
  background-color: white;
  color: #00875a;
  border: none;
  padding: 0.375rem;
  border-radius: 3px;
  cursor: pointer;
  font-size: 1.25rem;
  font-weight: 600;
  transition: all 0.15s ease;
  box-shadow: 0 1px 2px rgba(9, 30, 66, 0.08);
  line-height: 1;
  white-space: nowrap;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 2rem;
  height: 2rem;

  @media (min-width: 768px) {
    padding: 0.375rem 1rem;
    font-size: 0.875rem;
    height: auto;
    min-width: auto;
  }

  &:hover {
    background-color: #f4f5f7;
    box-shadow: 0 2px 4px rgba(9, 30, 66, 0.12);
  }

  &:active {
    background-color: #ebecf0;
    transform: scale(0.98);
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.5);
  }
`;

const ButtonText = styled.span`
  display: none;

  @media (min-width: 768px) {
    display: inline;
  }
`;

const ButtonIcon = styled.span`
  display: inline;

  @media (min-width: 768px) {
    display: none;
  }
`;

type ShiftHeaderProps = {
  year: number;
  month: number;
  workplaceName?: string;
  onPrevMonth: () => void;
  onNextMonth: () => void;
  onToday: () => void;
  onDownload: () => void;
};

export const ShiftHeader: React.FC<ShiftHeaderProps> = ({
  year,
  month,
  workplaceName,
  onPrevMonth,
  onNextMonth,
  onToday,
  onDownload,
}) => {
  const appShell = useAppShell();
  const shouldShowMenuButton =
    appShell && (window.innerWidth < 768 || !appShell.desktopSidebarOpen);

  return (
    <HeaderContainer>
      <HeaderContent>
        <LeftSection>
          {shouldShowMenuButton && (
            <MenuButton
              type="button"
              aria-label="ナビゲーションを開く"
              title="ナビゲーションを開く"
              onClick={() => {
                if (window.innerWidth >= 768) {
                  appShell.openDesktopNavigation();
                } else {
                  appShell.openMobileNavigation();
                }
              }}
            >
              ☰
            </MenuButton>
          )}
          <DateSection>
            <NavigationButtons>
              <NavButton onClick={onPrevMonth} aria-label="前月" title="前月">
                ‹
              </NavButton>
              <NavButton onClick={onNextMonth} aria-label="次月" title="次月">
                ›
              </NavButton>
            </NavigationButtons>
            <DateDisplay>{`${year}年 ${month}月`}</DateDisplay>
            <TodayButton onClick={onToday}>今月</TodayButton>
          </DateSection>
        </LeftSection>
        {workplaceName && <WorkplaceName>{workplaceName}</WorkplaceName>}
        <RightSection>
          <DownloadButton onClick={onDownload} title="ダウンロード" aria-label="ダウンロード">
            <ButtonIcon>⬇</ButtonIcon>
            <ButtonText>ダウンロード</ButtonText>
          </DownloadButton>
        </RightSection>
      </HeaderContent>
    </HeaderContainer>
  );
};
